/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiFormContainer from 'components/Forms/UiFormContainer'
import UiFormModalHeader from 'components/Forms/UiFormModalHeader'
import UiFormBody from 'components/Forms/UiFormBody'
import UiFormStickyFooter from 'components/Forms/UiFormStickyFooter'

interface UiFormModalShellProps {
    title: React.ReactNode
    subtitle?: React.ReactNode
    children: React.ReactNode | React.ReactNode[]
    className?: string
    bodyClassName?: string
    headerBottom?: React.ReactNode
    headerCenter?: React.ReactNode
    headerActions?: React.ReactNode
    footer?: React.ReactNode
    showHeader?: boolean
    showHeaderCompact?: boolean
}

const UiFormModalShell = (props: UiFormModalShellProps) => {
    return (
        <UiFormContainer
            className={clsx(
                'UiFormModalShell',
				props.className,
                'text-gray-900',
                'dark:text-white',
                'min-h-0',
            )}
        >
            {props.showHeader && (
                <UiFormModalHeader
                    title={props.title}
                    subtitle={props.subtitle}
                    bottom={props.headerBottom}
                    actions={props.headerActions}
                />
            )}
            {props.showHeaderCompact && (
                <div
                    className={clsx(
                        'UiFormModalShellCompactHeader sticky top-0 z-20 h-16 flex items-center px-6 transition-colors border-b border-gray-100 dark:border-white/5 gap-6 bg-white/90 dark:bg-gray-950/90 backdrop-blur-md',
                    )}
                >
                    {props.headerBottom && (
                        <div className="flex items-center h-full">
                            {props.headerBottom}
                        </div>
                    )}
                    {props.headerCenter && (
                        <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 flex items-center justify-center z-10 pointer-events-none">
                            <div className="pointer-events-auto">
                                {props.headerCenter}
                            </div>
                        </div>
                    )}
                    {props.headerActions && (
                        <div className="ml-auto flex items-center h-full gap-2 pr-10">
                            {props.headerActions}
                        </div>
                    )}
                </div>
            )}
            <UiFormBody
                className={clsx(
                    props.bodyClassName ? props.bodyClassName : 'px-6 py-6'
                )}
            >
                {props.children}
            </UiFormBody>
            {props.footer && (
                <UiFormStickyFooter>{props.footer}</UiFormStickyFooter>
            )}
        </UiFormContainer>
    )
}

export default UiFormModalShell
